import axios from "axios";
import React from 'react';
import * as constants from "../../../util/constants";
import Alert from "../../common/Alert";
import Breadcrumb from "../../common/Breadcrumb";
import ButtonBack from "../../common/ButtonBack";
import ButtonSave from "../../common/ButtonSave";
import FieldBirthDate from "../../common/FieldBirthDate";
import FieldPhone from "../../common/FieldPhone";
import FieldText from "../../common/FieldText";
import Propertii from "../../common/Propertii";

class Profile extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {
            landlord: {},
            validationList: {},
        };

        this.saveLandlord = this.saveLandlord.bind(this);
    }

    /**
     * Fetch the landlord's data based on the ID provided in the session.
     */
    componentDidMount() {

        axios.get(`${constants.REACT_APP_HOST_API_URL}/landlord/${this.props.userSession.sessionRole.id}`, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState(prevState => ({
                ...prevState,
                landlord: response.data
            }));
        }).catch(error => {
            this.handleValidation(error);
        });
    }

    /**
     * Handle the submission of the form.
     *
     * @param event - The event container.
     */
    saveLandlord(event) {

        event.preventDefault();

        axios.put(`${constants.REACT_APP_HOST_API_URL}/update`, this.state.landlord, {
            headers: this.generateRequestHeaders()
        }).then(response => {
            this.setState({
                validationList: [{
                    alert: {
                        type: 'primary',
                        code: 'saved',
                        message: 'Changes have been saved'
                    },
                    fields: {},
                }],
            })
        }).catch(error => {
            this.handleValidation(error);
        });

        window.scrollTo(0, 0);
    }

    /**
     * Render the component.
     *
     * @returns {*} - The edit profile component for administrators.
     */
    render() {

        return(
            <div className="content-block">

                <div className="container">

                    <Breadcrumb parentPath="/landlord/account" parentPage="Account" childPage="Edit Profile" />

                    <Alert validationList={this.state.validationList} />

                    <form onSubmit={this.saveLandlord}>

                        <div className="card">
                            <div className="card-header">
                                Profile Details
                            </div>
                            <div className="card-body">

                                <FieldText id="firstName" label="First Name" model="landlord" parent={this} value={this.state.landlord['firstName']} />

                                <FieldText id="lastName" label="Last Name" model="landlord" parent={this} value={this.state.landlord['lastName']} />

                                <FieldText id="email" label="Email" model="landlord" type="email" parent={this} value={this.state.landlord['email']} />

                                <FieldPhone id="phone" label="Phone" model="landlord" parent={this} value={this.state.landlord['phone']} optional={true} />

                                <FieldBirthDate id="birthDate" label="Birth Date" model="landlord" parent={this} value={this.state.landlord['birthDate']} monthFirst={true} />

                                <FieldText id="sin" label="Sin" model="landlord" parent={this} required={true} value={this.state.landlord['sin']} />

                            </div>
                        </div>

                        <div className="row">
                            <div className="col text-right">

                                <ButtonBack path="/landlord/account" />
                                <ButtonSave />

                            </div>
                        </div>

                    </form>

                </div>
            </div>
        )
    };
}

export default Profile;